import { render, staticRenderFns } from "./compareCourseList.vue?vue&type=template&id=4c75d3a0&scoped=true&"
import script from "./compareCourseList.vue?vue&type=script&lang=js&"
export * from "./compareCourseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c75d3a0",
  null
  
)

export default component.exports